import { useTranslation } from "react-i18next";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {QRCodeCanvas}  from "qrcode.react";
import useMobileAccess from "../../hooks/useMobileAccess";
import {useConfig} from "../../hooks/useConfig";
import {getShortName} from "../../utils/helpers";

export default function PublishModalRightPane({uniqueCode}) {
    const { t } = useTranslation();
  const isMobile = useMobileAccess();
  const config = useConfig();
  let shortName = getShortName();

  const INST_URL = shortName + '.' + config.host_url;
  return (
    <Container>
      <Row>
        <Col>
          <span className="scan-qr-text">{t("poll.scanQrCode")}</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <QRCodeCanvas
            bgColor={"#f6f6f6"}
            style={{ margin: "10px" }}
            renderAs="canvas"
            size={isMobile ? 180 : 250}
            value={INST_URL + "/qr/" + uniqueCode}
          />
        </Col>
      </Row>
    </Container>
  );
}
